import { Popover, Typography } from "@mui/material";
import { useState } from "react";
import { HexColorInput, HexColorPicker } from "react-colorful";

import "./ColorField.css";

interface ColorFieldProps {
  label: string;
  value: string;
  onChange: (hex: string) => void;
}

export function ColorField({ label, value, onChange }: ColorFieldProps) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <div className="color-field">
      <Typography variant="body2">{label}</Typography>
      <button
        type="button"
        aria-label={label}
        className="color-field-swatch"
        style={{ background: value }}
        onClick={(event) => setAnchor(event.currentTarget)}
      />
      <Popover
        open={anchor !== null}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div className="color-field-picker">
          <HexColorPicker color={value} onChange={onChange} />
          <HexColorInput color={value} onChange={onChange} prefixed aria-label={`${label} hex`} />
        </div>
      </Popover>
    </div>
  );
}
